import { useMemo } from 'react';
import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { INIT_MM_DATA_STATE, MMDataState } from '../types';
import { aggregateRoi } from '../utils/aggregateRoi';

export const useRoi = (
  enabled: boolean,
  investments: MMDataState,
  decomps: MMDataState,
) => {
  const { isEuro } = useKpiUnit();

  return useMemo(() => {
    if (!enabled) {
      return { roi: INIT_MM_DATA_STATE };
    }

    const roi = aggregateRoi(investments, decomps, isEuro);

    return { roi };
  }, [enabled, investments, decomps, isEuro]);
};
